import { render, staticRenderFns } from "./CompanyBlock.vue?vue&type=template&id=69df6912&scoped=true"
import script from "./CompanyBlock.vue?vue&type=script&lang=js"
export * from "./CompanyBlock.vue?vue&type=script&lang=js"
import style0 from "./CompanyBlock.vue?vue&type=style&index=0&id=69df6912&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69df6912",
  null
  
)

export default component.exports